<template>
    <div class="loading-container">

        <!-- Animated Background Blobs -->
        <div class="blob blob1"></div>
        <div class="blob blob2"></div>
        <div class="blob blob3"></div>

        <!-- Content -->
        <div class="content">
            <div class="logo-wrapper">
                <!-- Rotating Ring -->
                <div class="ring"></div>

                <!-- Logo -->
                <img
                    src="@/assets/logo/new/idea3.png"
                    alt="SweldoNow"
                    class="logo"
                />
            </div>

            <h1 class="product-name">SweldoNow</h1>

            <div class="maintenance-text amber--text text--darken-3">
                <span v-html="appStatusText"></span>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'SystemMaintenance',
    metaInfo: {
        title: 'System Maintenance',
        meta: [
            { charset: 'utf-8' },
            { name: 'description', content: 'SystemMaintenance' },
            { name: 'viewport', content: 'width=device-width, initial-scale=1' },
        ],
    },
    data() {
        return {}
    },
    computed: {
        appStatusText() {
            // Extracts the formatted completion time from the active route query parameters
            const endTime = this.$route.query.endTime

            if (endTime) {
                return `SweldoNow is currently undergoing scheduled maintenance. ${this.isMobile ? '' : '<br>'} Please check back after <strong>${endTime}</strong>.`
            }
            
            // Reusable fallback message string
            return `SweldoNow is currently undergoing scheduled maintenance. ${this.isMobile ? '' : '<br>'} Please check back later.`
        }
    }
}
</script>

<style scoped>
/* CSS blocks stay completely identical to your clean animation configurations */
.loading-container {
    position: relative;
    width: 100%;
    height: 100vh;
    overflow: hidden;
    background: #ffffff;
    display: flex;
    justify-content: center;
    align-items: center;
}
.content {
    text-align: center;
    z-index: 10;
}
.product-name {
    font-family: 'Inter', sans-serif !important;
    margin-top: 26px;
    font-size: 42px;
    font-weight: 500;
    color: #1976D2;
    animation: fadeUp .8s ease;
}
.tagline {
    font-family: 'Inter', sans-serif !important;
    font-size: 14px; /* Increased from 12px for better readability on small screens */
    font-weight: 500;
    color: #37474F; /* Explicit dark slate grey to pass WCAG contrast checks against background blobs */
   
    opacity: 0.85;
}
.logo-wrapper {
    position: relative;
    width: 140px;
    height: 140px;
    margin: auto;
    animation: float 3s ease-in-out infinite;
}
.logo {
    position: absolute;
    top: 20px;
    left: 20px;
    width: 100px;
    height: 100px;
    object-fit: contain;
    z-index: 2;
}
.ring {
    position: absolute;
    width: 140px;
    height: 140px;
    border-radius: 50%;
    border: 2px solid rgba(25, 118, 210, .15);
    border-top: 2px solid #1976D2;
    animation: spin 3s linear infinite;
}
.blob {
    position: absolute;
    border-radius: 50%;
    filter: blur(90px);
    opacity: .45;
}
.blob1 {
    width: 350px;
    height: 350px;
    background: #90CAF9;
    top: -100px;
    left: -100px;
    animation: moveBlob1 10s ease-in-out infinite alternate;
}
.blob2 {
    width: 300px;
    height: 300px;
    background: #64B5F6;
    right: -100px;
    top: 20%;
    animation: moveBlob2 12s ease-in-out infinite alternate;
}
.blob3 {
    width: 400px;
    height: 400px;
    background: #BBDEFB;
    bottom: -150px;
    left: 35%;
    animation: moveBlob3 14s ease-in-out infinite alternate;
}
@keyframes float {
    0%, 100% { transform: translateY(0px); }
    50% { transform: translateY(-12px); }
}
@keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}
@keyframes moveBlob1 {
    from { transform: translate(0, 0); }
    to { transform: translate(120px, 80px); }
}
@keyframes moveBlob2 {
    from { transform: translate(0, 0); }
    to { transform: translate(-120px, 100px); }
}
@keyframes moveBlob3 {
    from { transform: translate(0, 0); }
    to { transform: translate(100px, -100px); }
}
@keyframes fadeUp {
    from { opacity: 0; transform: translateY(15px); }
    to { opacity: 1; transform: translateY(0); }
}
.maintenance-text {
    margin-top: 32px;
    font-size: 18px;
    font-weight: 400;
    
    /* Crucial UX Fix: Lock the height so multi-line text wraps 
       internally and never shifts the page layout or bounces the layout container */
    min-height: 44px; 
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 24px; /* Keeps text clear of edge boundaries on narrow phones */
}
@keyframes dots {
    0%   { content: ''; }
    25%  { content: '.'; }
    50%  { content: '..'; }
    75%, 100% { content: '...'; }
}
</style>
